import i18n, { translate as $t } from '../i18n/i18n'
import * as constants from 'client/modules/constants'

const i18n_mixin = {}

i18n_mixin.install = function(Vue) {
  Vue.mixin({
    computed: {
      $DEFAULT_HOST() { return constants.DEFAULT_HOST }
    },
    created() {
      try {
        if (this.$t('common.defaultHost') !== constants.DEFAULT_HOST) {
          i18n.addResourceBundle('en', 'common', {
            'defaultHost': constants.DEFAULT_HOST
          })
        }
      } catch (e) {
        // do nothing.  this only seems to occur in tests.
      }
    },
    methods: { $t }
  })

}

export default i18n_mixin
